import Sidebar from "@common/components/Sidebar";
import SidebarLink from "@common/components/Sidebar/SidebarLink";
import {
  HiOutlineChartBar,
  HiOutlineClipboardList,
  HiOutlineCog,
  HiOutlineEye,
  HiOutlineGlobe,
  HiOutlineHome,
  HiOutlineLogout,
  HiOutlineViewGrid,
} from "react-icons/hi";
// Heroicons v2 — v1 (react-icons/hi, used for every other icon here) has no
// wrench. Its outline strokes lighter than its neighbours as a result.
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";
import { AdvisorRoutes, FeatureFlags } from "@common/constants";
import useStore from "@common/state";
import { useAtlasExperience, useLogout, useViewAsAdvisor } from "@common/hooks";
import { useFlags } from "launchdarkly-react-client-sdk";
import CasesTasksSidebarLink from "./CasesTasksSidebarLink";

const AdvisorSidebar = () => {
  const { isSidebarExpanded } = useStore();
  const { setShowLogoutDialog } = useLogout();
  const { isAtlasExperienceEnabled } = useAtlasExperience();
  const flags = useFlags();
  const { viewAs } = useViewAsAdvisor();
  return (
    <Sidebar showAdvisorAccess={false}>
      <div className="flex flex-1 flex-col overflow-y-auto overflow-x-hidden scrollbar-none">
        <div className={"sidebar-section-header px-10 "}>
          <span
            className={`${
              isSidebarExpanded
                ? "sidebar-section-text-expanded"
                : "sidebar-section-text-collapsed"
            }`}
          >
            Wealth Advisor
          </span>
        </div>
        <SidebarLink
          href={AdvisorRoutes.Households}
          icon={<HiOutlineHome />}
          text="Households"
        />
        {flags[FeatureFlags.COMMAND_CENTER] && (
          <SidebarLink
            href={AdvisorRoutes.CommandCenter}
            icon={<HiOutlineViewGrid />}
            text="Command Center"
            query={viewAs ? { viewAs } : undefined}
          />
        )}
        {flags[FeatureFlags.COMMAND_CENTER] && (
          <SidebarLink
            href={AdvisorRoutes.MyPractice}
            icon={<HiOutlineClipboardList />}
            text="My Practice"
            query={viewAs ? { viewAs } : undefined}
          />
        )}
        {flags[FeatureFlags.COMMAND_CENTER] &&
          flags[FeatureFlags.CASES_AND_TASKS] && <CasesTasksSidebarLink />}
        {isAtlasExperienceEnabled && (
          <SidebarLink
            href={AdvisorRoutes.Atlas}
            icon={<HiOutlineGlobe />}
            text="Atlas"
          />
        )}
        {flags[FeatureFlags.TEAM_METRICS_DASHBOARD] && (
          <SidebarLink
            href={AdvisorRoutes.TeamMetrics}
            icon={<HiOutlineChartBar />}
            text="Team Metrics"
          />
        )}
        {flags[FeatureFlags.ATLAS_ADMINS] && (
          <SidebarLink
            href={AdvisorRoutes.Observability}
            icon={<HiOutlineEye />}
            text="Observability"
          />
        )}
        {flags[FeatureFlags.UXT_TESTING] && (
          <SidebarLink
            href={AdvisorRoutes.UxtTesting}
            icon={<HiOutlineWrenchScrewdriver />}
            text="UXT Testing"
            // Carry the impersonation across, or an admin arrives with no
            // ?viewAs= and every link re-renders pointing at their own book.
            query={viewAs ? { viewAs } : undefined}
          />
        )}
        <div className={"sidebar-section-header px-10 "}>
          <span
            className={`${
              isSidebarExpanded
                ? "sidebar-section-text-expanded"
                : "sidebar-section-text-collapsed"
            }`}
          >
            Settings
          </span>
        </div>
        <SidebarLink
          href={AdvisorRoutes.Settings}
          icon={<HiOutlineCog />}
          text="Settings"
        />
        <SidebarLink
          text="Log Out"
          icon={<HiOutlineLogout />}
          href=""
          onClickLink={() => setShowLogoutDialog(true)}
        />
      </div>
    </Sidebar>
  );
};

export default AdvisorSidebar;
